import axios  from "../../utils/axios";

export const create_costs = async (payload) => {
    const response = await axios.post(`/admin/costs`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: payload,
    });
    const {data} = response;

    return data;
};

export const get_all_costs = async (date) => {
    const response = await axios.get(`/admin/costs?month=${date?.monthNum}`);
    const {data} = response;

    return data;
};

export const update_cost = async (id, payload) => {
    const response = await axios.put(`/admin/costs/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: payload,
    });
    const {data} = response;

    return data;
};

export const delete_costs = async (id) => {
    const response = await axios.delete(`/admin/costs/${id}`, );
    const {data} = response;

    return data;
};